import { useAtom } from "jotai";
import { navbarAtom } from "../../lib/atoms";
import clsx from "clsx";
import MenuLink from "./MenuLink";
import {
  Book,
  Euro,
  FileIcon,
  FileMinus,
  MailQuestion,
  ShoppingBag,
  SquarePen,
  User,
  Users2,
  Video,
} from "lucide-react";
import Divider from "../ui/Divider";
import { useAuthStatus } from "../../lib/stores/auth-store";

const Navbar = () => {
  const [navbarOpen, setNavbar] = useAtom(navbarAtom);
  const signOut = useAuthStatus((state) => state.logout);

  return (
    <div
      className={clsx(
        "z-50 bg-white p-2 h-screen md:w-56 border-r transition duration-200 border-slate-200 fixed w-screen flex flex-col gap-1 mt-14 md:mt-20",
        { "left-0": navbarOpen, "-left-full md:left-0": !navbarOpen }
      )}
    >
      <MenuLink to='/' icon={<Book className='h-full w-full' />} label='Abonnement' />
      <MenuLink to='/syndicat' icon={<Users2 className='h-full w-full' />} label='Syndicat' />
      <MenuLink to='/revues-numeriques' icon={<FileIcon className='h-full w-full' />} label='Revue numérique' />
      <MenuLink to='/boutique' icon={<ShoppingBag className='h-full w-full' />} label='Boutique' />
      <MenuLink to='/attestations' icon={<FileMinus className='h-full w-full' />} label='Attestations' />
      <MenuLink to='/factures' icon={<Euro className='h-full w-full' />} label='Factures' />
      <MenuLink to='/petites-annonces' icon={<SquarePen className='h-full w-full' />} label='Petites annonces' />
      <MenuLink to='/webinaires' icon={<Video className='h-full w-full' />} label='Webinaires' />
      <Divider />
      <MenuLink to='/aide' icon={<MailQuestion className='h-full w-full' />} label='Nous contacter' />
      <div className='block md:hidden'>
        <MenuLink to='/coordonnees' icon={<User className='h-full w-full' />} label='Mes coordonnées' />
        {/* <Divider /> */}
        <div
          onClick={() => {
            signOut();
            setNavbar(false);
          }}
          className='text-red-400 rounded-lg font-medium p-2 text-center mt-12 bg-red-50'
        >
          Déconnexion
        </div>
      </div>
    </div>
  );
};

export default Navbar;
